import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import './HomePage.css';


export function HomePage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<string | null>(null);

  useEffect(() => {
    const checkLastGame = async () => {
      // Проверяем, не установлен ли флаг явного выхода на главную
      const skipAutoRedirect = localStorage.getItem('skip-auto-redirect');
      if (skipAutoRedirect === 'true') {
        // Пользователь явно вышел на главную, не делаем автоматический переход
        localStorage.removeItem('skip-auto-redirect');
        return;
      }
      
      // Проверяем, есть ли сохраненная последняя игра
      const lastGame = localStorage.getItem('last-game');
      if (lastGame) {
        try {
          const { gameId, gameType } = JSON.parse(lastGame);
          
          // Проверяем, что игра еще активна
          try {
            const response = await api.get(`/games/${gameId}`);
            const game = response.data;
            
            if (game && game.status === 'active') {
              // Игра активна, переходим к ней
              navigate(`/games/${gameType}/${gameId}`);
              return;
            }
          } catch (error: any) {
            // Игра не найдена или неактивна, или backend недоступен
            // Не логируем ошибки 504/503, так как это временные проблемы с backend
            if (error?.response?.status !== 504 && error?.response?.status !== 503) {
              console.log('Last game not found or inactive');
            }
          }
        } catch (e) {
          // Игнорируем ошибки парсинга
        }
      }
    };
    
    checkLastGame();
  }, []);


  const createGame = async (gameType: 'base' | 'plates' | 'roulette' | 'regions', config?: any) => {
    console.log('createGame called:', { gameType, config });
    setLoading(gameType);
    try {
      console.log('Sending POST request to /games with:', { gameType, ...config });
      const response = await api.post('/games', {
        gameType,
        ...config,
      });
      console.log('Response received:', response.data);
      const gameId = response.data.id;
      
      if (!gameId) {
        console.error('No gameId in response:', response.data);
        throw new Error('No gameId in response');
      }
      
      // Сохраняем последнюю игру
      localStorage.setItem('last-game', JSON.stringify({ gameId, gameType }));
      
      console.log('Navigating to:', `/games/${gameType}/${gameId}`);
      navigate(`/games/${gameType}/${gameId}`);
    } catch (error: any) {
      console.error('Error creating game:', error);
      console.error('Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      alert(error.response?.data?.error?.message || error.message || 'Ошибка создания игры');
    } finally {
      setLoading(null);
    }
  };


  const handleCreateBase = async () => {
    // Backend will check for existing active game and return it if found
    // No need to check on frontend - just create/continue game
    createGame('base');
  };

  const handleCreatePlates = () => {
    // Получаем сохраненный digitalPart или используем пустую строку
    const savedDigitalPart = localStorage.getItem('last-plates-digital-part');
    const defaultValue = savedDigitalPart || '';
    
    const digitalPart = prompt('Введите цифровую часть (001-999):', defaultValue);
    if (digitalPart) {
      const num = parseInt(digitalPart, 10);
      if (num >= 1 && num <= 999) {
        // Сохраняем digitalPart для следующего раза
        localStorage.setItem('last-plates-digital-part', digitalPart);
        createGame('plates', { digitalPart: num });
      } else {
        alert('Число должно быть от 1 до 999');
      }
    }
  };

  const handleCreateRoulette = () => {
    const regionCode = prompt('Введите код региона (1-999):');
    if (regionCode) {
      const num = parseInt(regionCode, 10);
      if (num >= 1 && num <= 999) {
        createGame('roulette', { regionCode: num });
      } else {
        alert('Код региона должен быть от 1 до 999');
      }
    }
  };

  const handleCreateRegions = () => {
    // Backend will check for existing active game and return it if found
    // No need to check on frontend - just create/continue game
    createGame('regions');
  };

  return (
    <div className="home-page">
      <div className="home-container">
        <h1>Numbermania</h1>
        <p className="subtitle">Выберите тип игры</p>


        <div className="game-types">
          <button
            className="game-type-card"
            onClick={handleCreateBase}
            disabled={loading !== null}
          >
            <h2>Базовый</h2>
            <p>Погасить все числа от 001 до 999</p>
            {loading === 'base' && <div className="loader">Загрузка...</div>}
          </button>

          <button
            className="game-type-card"
            onClick={handleCreatePlates}
            disabled={loading !== null}
          >
            <h2>Номера</h2>
            <p>Поиск автомобильных номеров</p>
            {loading === 'plates' && <div className="loader">Загрузка...</div>}
          </button>

          <button
            className="game-type-card"
            onClick={handleCreateRoulette}
            disabled={loading !== null}
          >
            <h2>Рулетка</h2>
            <p>Поиск случайного номера в регионе</p>
            {loading === 'roulette' && <div className="loader">Загрузка...</div>}
          </button>

          <button
            className="game-type-card"
            onClick={handleCreateRegions}
            disabled={loading !== null}
          >
            <h2>Регионы</h2>
            <p>Погасить все регионы РФ</p>
            {loading === 'regions' && <div className="loader">Загрузка...</div>}
          </button>
        </div>

        <div className="home-actions">
          <button
            className="secondary-button"
            onClick={() => navigate('/history')}
          >
            История игр
          </button>
          <button
            className="secondary-button"
            onClick={() => navigate('/profile')}
          >
            Профиль
          </button>
        </div>
      </div>
    </div>
  );
}

